import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import blankProfileImg from "../Assets/avatar.png";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";
import { storeData } from "../LocalConnection/LocalConnection";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import MasterLayout from "../masterLayout/MasterLayout";
import {
  edit_profile,
  server_post_data,
  update_profile,
  business_business_data,
} from "../ServiceConnection/serviceconnection";
import "./CSS/Profile.css";
import Loader from "../pages/Loader";
export default function Profile() {
  const [activeTab, setActiveTab] = useState("personal");
  const [imagePreview, setImagePreview] = useState(blankProfileImg);
  const [busimagePreview, setbusImagePreview] = useState(blankProfileImg);
  const [image, setImage] = useState([]);
  const [busimage, setbusImage] = useState([]);
  const [image_old, setImage_old] = useState("");
  const [busImgFlag, setbusImgflag] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  // const [businessLocation, setBusinessLocation] = useState(""); // Location input value
  // const [formErrors, setFormErrors] = useState({});
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
  const [allConditionsMet, setAllConditionsMet] = useState(false);
  const [passwordConditions, setPasswordConditions] = useState({
    hasUppercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneManager, setPhoneManager] = useState("");

  const [formErrors, setFormErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    businessName: "",
    businessEmail: "",
    businessLocation: "",
  });
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [customerDesignation, setCustomerDesignation] = useState([]);
  const [customerid, setCustomerid] = useState("s");
  //bssiness
  const [businessName, setBusinessName] = useState("");
  const [businessLocation, setBusinessLocation] = useState("");
  const [businessWebsite, setBusinessWebsite] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [gstSelected, setGstSelected] = useState("No");
  const [gstInputSHow, setgstInputSHow] = useState(false);
  const [gst, setgst] = useState("");
  const [gstFocus, setgstFocus] = useState(false);
  const [shake, setShake] = useState({
    businessName: false,
    phoneNumber: false,
    location: false,
    website: false,
    category: false,
  });
  const [submitted, setSubmitted] = useState({
    businessName: false,
    phoneNumber: false,
    location: false,
    website: false,
    category: false,
    gst: false,
  });
  const handlegstChange = (e) => setgst(e.target.value);
  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(edit_profile, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log(final_data);
          if (final_data.edit_user.length > 0) {
            console.log(final_data.edit_business);
            setBusinessName(final_data.edit_business[0].business_name);
            setBusinessEmail(final_data.edit_business[0].bus_email);
            setBusinessLocation(final_data.edit_business[0].business_location);
            setgst(final_data.edit_business[0].gst_no);
            setPhoneManager(final_data.edit_business[0].bus_moblie_no);
            setBusinessWebsite(
              final_data.edit_business[0].business_website_url,
            );
            setbusImagePreview(
              final_data.business_linkss_link +
                final_data.edit_business[0].website_logo,
            );
            if (final_data.edit_business[0].website_logo == null) {
              setbusImgflag(0);
            } else {
              setbusImgflag(1);
            }
            setCustomerDesignation(final_data.edit_user[0].designation);
            setFullName(final_data.edit_user[0].full_name);
            setEmail(final_data.edit_user[0].email_id);
            setPhone(final_data.edit_user[0].mobile_no);
            setCustomerid(final_data.edit_user[0].buu_id);
            setImage_old(final_data.edit_user[0].image);
            if (
              final_data.edit_business[0].gst_no !== null &&
              final_data.edit_business[0].gst_no !== ""
            ) {
              handleGstChange("Yes");
            }
            if (final_data.edit_user[0].image !== null) {
              setImagePreview(
                final_data.user_linkss_link + final_data.edit_user[0].image,
              );
            }
            storeData("user_image", final_data.edit_user[0].image);
            storeData("final_full_name", final_data.edit_user[0].full_name);
            storeData("final_user_email", final_data.edit_user[0].email_id);
          }
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);

  console.log(gst);

  console.log("Bus Flag", busImgFlag);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };
  const handlePasswordChange = (event) => {
    const passwordValue = event.target.value;
    setPassword(passwordValue);

    // Regular expressions to check password conditions
    const uppercasePattern = /[A-Z]/;
    const numberPattern = /\d/;
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;

    // Update the conditions based on the password input
    const updatedConditions = {
      hasUppercase: uppercasePattern.test(passwordValue),
      hasNumber: numberPattern.test(passwordValue),
      hasSpecialChar: specialCharPattern.test(passwordValue),
    };

    // Set the password conditions
    setPasswordConditions(updatedConditions);

    // Check if all conditions are met to hide the validation list
    setAllConditionsMet(
      updatedConditions.hasUppercase &&
        updatedConditions.hasNumber &&
        updatedConditions.hasSpecialChar,
    );

    // If password changes, validate confirm password
    if (confirmPassword && passwordValue !== confirmPassword) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }
  };

  const handleConfirmPasswordChange = (event) => {
    const confirmPasswordValue = event.target.value;
    setConfirmPassword(confirmPasswordValue);

    // Check if the confirm password matches the password
    if (password && confirmPasswordValue !== password) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }
  };

  const handleBlur = () => {
    if (password !== confirmPassword) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "Passwords do not match",
      }));
    } else {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));
    }
  };
  const handleGstChange = (value) => {
    setgstInputSHow(value === "Yes");
    setGstSelected(value);
  };

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const reader = new FileReader();
      setImage(input.target.files[0]);
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  const readbusURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      setbusImgflag(0);
      const reader = new FileReader();
      setbusImage(input.target.files[0]);
      reader.onload = (e) => {
        setbusImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.target.files[0]);
    }
  };

  const handleInputChange = (field, value) => {
    if (field === "fullName") {
      const fullNameRegex = /^[A-Za-z\s]+$/;

      if (fullNameRegex.test(value)) {
        setFullName(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          fullName: value ? "" : "Full Name is required",
        }));
      } else {
        setFullName(value.slice(0, -1));
      }
    } else if (field === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;

      if (validEmailChars.test(value)) {
        setEmail(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          email: emailRegex.test(value)
            ? ""
            : "Please enter a valid email address",
        }));
      } else {
        setEmail(value.slice(0, -1));
      }
    } else if (field === "phone") {
      const phoneRegex = /^[0-9]*$/;
      if (phoneRegex.test(value)) {
        setPhone(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: value ? "" : "Phone number is required",
        }));
      } else {
        setPhone(value.slice(0, -1));
      }
    }
  };
  const handleBusinessInputChange = (field, value) => {
    if (field === "businessName") {
      const businessNameRegex = /^[A-Za-z\s]+$/;

      if (businessNameRegex.test(value)) {
        setBusinessName(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          businessName: value ? "" : "Business Name is required",
        }));
      } else {
        setBusinessName(value.slice(0, -1));
      }
    } else if (field === "businessLocation") {
      const locationRegex = /^[A-Za-z\s]+$/;

      if (locationRegex.test(value)) {
        setBusinessLocation(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          businessLocation: value ? "" : "Business Location is required",
        }));
      } else {
        setBusinessLocation(value.slice(0, -1));
      }
    } else if (field === "businessWebsite") {
      // Optional website with basic URL validation
      const websiteRegex =
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

      setBusinessWebsite(value);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        businessWebsite:
          value && !websiteRegex.test(value)
            ? "Please enter a valid website URL"
            : "",
      }));
    } else if (field === "businessEmail") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;

      if (validEmailChars.test(value)) {
        setBusinessEmail(value);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          businessEmail: emailRegex.test(value)
            ? ""
            : "Please enter a valid business email address",
        }));
      } else {
        setBusinessEmail(value.slice(0, -1));
      }
    }
  };
  // console.log(image)
  const handleSave = async () => {
    let errors = {};
    if (!fullName) errors.fullName = "Full Name is required";
    if (!email) errors.email = "Email is required";
    if (!phone) errors.phone = "Phone number is required";

    // Set errors state
    setFormErrors(errors);

    // If no errors, proceed to save
    if (Object.keys(errors).length === 0) {
      // Log or save data here
      console.log({
        fullName,
        email,
        phone,
      });

      setShowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("staff_name", fullName);
      fd_from.append("email_staff", email);
      fd_from.append("image", image);
      fd_from.append("old_image", image_old);
      fd_from.append("staf_desig", customerDesignation);
      fd_from.append("user_idd", customerid);
      fd_from.append("website_logo", customerid);
      await server_post_data(update_profile, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            master_data_get();
            handleSuccess("Saved Successfully");
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
    }
  };
  const handleBusinessSave = async () => {
    let errors = {};
    if (!businessName) errors.businessName = "Business Name is required";
    if (!businessLocation)
      errors.businessLocation = "Business Location is required";
    if (!businessEmail) errors.businessEmail = "Business Email is required";

    // Website validation is optional
    if (
      businessWebsite &&
      !/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(
        businessWebsite,
      )
    ) {
      errors.businessWebsite = "Please enter a valid website URL";
    }
    // Email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (businessEmail && !emailRegex.test(businessEmail)) {
      errors.businessEmail = "Please enter a valid business email address";
    }

    // Set errors state
    setFormErrors(errors);

    // If no critical errors, proceed to save
    if (!errors.businessName && !errors.businessLocation) {
      setShowLoaderAdmin(true);
      let fd_from = new FormData();
      fd_from.append("business_name", businessName);
      fd_from.append("business_location", businessLocation);
      fd_from.append("bus_email", businessEmail);
      fd_from.append("business_website_url", businessWebsite);
      fd_from.append("gst_no", gst);
      fd_from.append("city", city);
      fd_from.append("state", state);
      fd_from.append("phonemanager", phoneManager);
      fd_from.append("country", country);
      fd_from.append("lat", coordinates.lat);
      fd_from.append("long", coordinates.lng);

      if (busImgFlag === 0) {
        fd_from.append("image_url", busimage);
      } else if (busImgFlag === 1) {
        fd_from.append("image_old", busimagePreview.split("/").pop());
      }

      fd_from.append("business_website", businessWebsite || "");
      // Add other necessary fields for business profile

      await server_post_data(business_business_data, fd_from)
        .then((Response) => {
          setShowLoaderAdmin(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            handleSuccess("Saved Successfully");
          }
        })
        .catch((error) => {
          console.log(error);
          setShowLoaderAdmin(false);
        });
    }
  };

  console.log(busimagePreview.split("/").pop());

  const getInputStyle = (field) => {
    if (formErrors[field]) {
      return { border: "1px solid red" };
    }
    return {};
  };

  const handleSelect = async (address) => {
    setBusinessLocation(address); // Set the input value to the selected address
    try {
      // Geocode the selected address to get results
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);

      // Log details
      console.log("Selected Address:", address);
      console.log("Latitude:", latLng.lat);
      console.log("Longitude:", latLng.lng);

      const addressComponents = results[0].address_components;
      let city = "";
      let province = "";
      let country = "";

      // Parse address components
      addressComponents.forEach((component) => {
        if (component.types.includes("locality")) {
          city = component.long_name; // City
        } else if (component.types.includes("administrative_area_level_1")) {
          province = component.long_name; // Province/State
        } else if (component.types.includes("country")) {
          country = component.long_name; // Country
        }
      });

      // Update state
      setCoordinates(latLng);
      setCity(city);
      setState(province);
      setCountry(country);

      // Save coordinates to state (if needed)
      setCoordinates(latLng);
    } catch (error) {
      console.error("Error fetching location details:", error);
    }
  };

  console.log(gst);

  return (
    <div>
      {ShowLoaderAdmin && <Loader />}
      <MasterLayout>
        <div className="EditProfileDiv">
          {/* <div className="titleHead">
            <h2>Edit profile</h2>
          </div> */}
          <div className="profile-tabs">
            <button
              className={`tab-button ${
                activeTab === "personal" ? "active" : ""
              }`}
              onClick={() => setActiveTab("personal")}
            >
              Personal Profile
            </button>
            <button
              className={`tab-button ${
                activeTab === "business" ? "active" : ""
              }`}
              onClick={() => setActiveTab("business")}
            >
              Business Profile
            </button>
          </div>

          {activeTab === "personal" && (
            <div className="profile_height_overFlow">
              <div className="mt-24 profileImgContr">
                <div className="avatar-upload">
                  <div className="avatar-edit position-absolute bottom-0 end-0 z-1 cursor-pointer">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      hidden
                      onChange={readURL}
                    />
                    <label
                      htmlFor="imageUpload"
                      className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                    >
                      <Icon icon="solar:camera-outline" className="icon"></Icon>
                    </label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${imagePreview})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </div>
                </div>

                <div className="imgTegLine">
                  <p>Profile image</p>
                </div>
              </div>
              <div className="row profileContainer">
                <div className="col-md-6 ImgContainerProfile">
                  <div className="row">
                    {/*---------- Name ---------- */}
                    <div className="col-md-12 mt-3">
                      <label htmlFor="fullName" className="form-label">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fullName"
                        value={fullName}
                        maxLength={50}
                        placeholder="Enter Full Name"
                        onChange={(e) =>
                          handleInputChange("fullName", e.target.value)
                        }
                        style={getInputStyle("fullName")}
                      />
                      {formErrors.fullName && (
                        <span className="text-danger condiErrr">
                          {formErrors.fullName}
                        </span>
                      )}
                    </div>
                    {/*---------- Email ---------- */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="email" className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        placeholder="Enter Email"
                        maxLength={60}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        style={getInputStyle("email")}
                        disabled
                      />
                      {formErrors.email && (
                        <span className="text-danger condiErrr">
                          {formErrors.email}
                        </span>
                      )}
                    </div>
                    {/*---------- Phone ---------- */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="phone" className="form-label">
                        Phone
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        value={phone}
                        maxLength={12}
                        placeholder="Enter Phone Number"
                        onChange={(e) =>
                          handleInputChange("phone", e.target.value)
                        }
                        style={getInputStyle("phone")}
                      />
                      {formErrors.phone && (
                        <span className="text-danger condiErrr">
                          {formErrors.phone}
                        </span>
                      )}
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="profileSavebttn">
                        <button type="button" onClick={() => handleSave()}>
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "business" && (
            <div className="profile_height_overFlow">
              <div className="mt-24 profileImgContr">
                <div className="avatar-upload">
                  <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      hidden
                      onChange={readbusURL}
                    />
                    <label
                      htmlFor="imageUpload"
                      className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                    >
                      <Icon icon="solar:camera-outline" className="icon"></Icon>
                    </label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${busimagePreview})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </div>
                </div>

                <div className="imgTegLine">
                  <p>Bussiness logo image</p>
                </div>
              </div>
              <div className="row profileContainer">
                <div className="col-md-6 ImgContainerProfile">
                  <div className="row">
                    {/*---------- Name ---------- */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="fullName" className="form-label">
                        Bussiness Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="businessName"
                        value={businessName}
                        maxLength={50}
                        placeholder="Enter Business Name"
                        onChange={(e) =>
                          handleBusinessInputChange(
                            "businessName",
                            e.target.value,
                          )
                        }
                        style={getInputStyle("businessName")}
                      />
                      {formErrors.businessName && (
                        <span className="text-danger condiErrr">
                          {formErrors.businessName}
                        </span>
                      )}
                    </div>
                    {/*---------- Phone ---------- */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="phone" className="form-label">
                        Bussiness Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        value={phoneManager}
                        maxLength={12}
                        placeholder="Enter Phone Number"
                        onChange={(e) =>
                          handleInputChange("phone", e.target.value)
                        }
                        style={getInputStyle("phone")}
                      />
                      {formErrors.phone && (
                        <span className="text-danger condiErrr">
                          {formErrors.phone}
                        </span>
                      )}
                    </div>
                    {/*---------- Email ---------- */}
                    <div className="col-md-6 mt-3">
                      <label htmlFor="email" className="form-label">
                        Bussiness Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="businessEmail"
                        value={businessEmail}
                        placeholder="Enter Business Email"
                        maxLength={60}
                        onChange={(e) =>
                          handleBusinessInputChange(
                            "businessEmail",
                            e.target.value,
                          )
                        }
                        style={getInputStyle("businessEmail")}
                      />
                      {formErrors.businessEmail && (
                        <span className="text-danger condiErrr">
                          {formErrors.businessEmail}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mt-3">
                      <label htmlFor="fullName" className="form-label">
                        Business Location <span className="text-danger">*</span>
                      </label>
                      <PlacesAutocomplete
                        value={businessLocation}
                        onChange={(value) =>
                          handleBusinessInputChange("businessLocation", value)
                        }
                        onSelect={handleSelect}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            {/* Input Field */}
                            <input
                              {...getInputProps({
                                type: "text",
                                className: "form-control",
                                id: "businessLocation",
                                maxLength: 50,
                                placeholder: "Enter Business Location",
                                style: getInputStyle("businessLocation"),
                              })}
                            />
                            {formErrors.businessLocation && (
                              <span className="text-danger condiErrr">
                                {formErrors.businessLocation}
                              </span>
                            )}

                            {/* Dropdown for Suggestions */}
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion) => {
                                const style = suggestion.active
                                  ? {
                                      backgroundColor: "#f0f0f0",
                                      cursor: "pointer",
                                      padding: "10px",
                                    }
                                  : {
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                      padding: "10px",
                                    };

                                return (
                                  <div
                                    key={suggestion.placeId}
                                    {...getSuggestionItemProps(suggestion, {
                                      style,
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div>
                    <div className="col-md-12 mt-3">
                      <label htmlFor="businessWebsite" className="form-label">
                        Bussiness Website
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="businessWebsite"
                        value={businessWebsite}
                        maxLength={100}
                        placeholder="Enter Website URL"
                        onChange={(e) =>
                          handleBusinessInputChange(
                            "businessWebsite",
                            e.target.value,
                          )
                        }
                        style={getInputStyle("businessWebsite")}
                      />
                      {formErrors.businessWebsite && (
                        <span className="text-danger condiErrr">
                          {formErrors.businessWebsite}
                        </span>
                      )}
                    </div>
                    {/* Gst */}

                    {gst === null || gst === "" ? (
                      <div className="upgstContr">
                        <h2>Do you want to edit GST Number ?</h2>

                        <div className="yesDivgst">
                          <input
                            className="ProfileRedioBtns"
                            type="radio"
                            id="yes"
                            name="gst"
                            value="Yes"
                            checked={gstSelected === "Yes"}
                            onChange={(e) => handleGstChange("Yes")}
                          />
                          <label htmlFor="yes">
                            <h3>Yes</h3>
                          </label>
                        </div>
                        <div className="yesDivgst">
                          <input
                            className="ProfileRedioBtns"
                            type="radio"
                            id="no"
                            name="gst"
                            value="No"
                            checked={gstSelected === "No"}
                            onChange={(e) => handleGstChange("No")}
                          />
                          <label htmlFor="no">
                            <h3>No</h3>
                          </label>
                        </div>
                      </div>
                    ) : (
                      <label
                        htmlFor="businessWebsite"
                        className=" form-label"
                        style={{ marginTop: "1rem" }}
                      >
                        GST Number
                      </label>
                    )}
                    {/* Gst Input Type filed */}

                    {gstInputSHow && (
                      <div className="col-sm-12 mt-3">
                        <div className="restName">
                          <label
                            className={`HeadBussiness ${
                              gst || gstFocus ? "active" : ""
                            }`}
                          >
                            GST No.<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter GST Number *"
                            className={`form-control ${
                              shake.gst ? "shake" : ""
                            }`}
                            value={gst}
                            maxLength={15}
                            onChange={handlegstChange}
                            onFocus={() => setgstFocus(true)}
                            onBlur={() => setgstFocus(false)}
                            required
                          />
                          {submitted.gst && gst.trim() === "" && (
                            <span className="conditonMsgSHow">
                              Please enter a GST Number
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-md-12 mt-3">
                      <div className="profileSavebttn">
                        <button
                          type="button"
                          onClick={() => handleBusinessSave()}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </MasterLayout>
    </div>
  );
}
